<template>
  <BottomSheetModal ref="component" headerBg="#fff">
    <TransactionDetails
      :reference="reference"
      v-if="reference"
      :key="reference"
    />
  </BottomSheetModal>
</template>

<script>
import { defineComponent } from 'vue'
import TransactionDetails from './TransactionDetails.vue'
import BottomSheetModal from '../utils/BottomSheetModal.vue'

export default defineComponent({
  name: 'TransactionDetailsComponent',
  components: { TransactionDetails, BottomSheetModal },
  props: {},
  data() {
    return {
      reference: '',
      eventsIds: [],
    }
  },
  mounted() {
    const id = this.$Events.handleEvent(
      'transaction_details_requested_bottomsheet',
      this.onTransactionDetailsRequested,
    )
    this.eventsIds.push(id)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    onTransactionDetailsRequested(data) {
      if (!data || !data.reference) return
      this.reference = data.reference
      this.$refs.component.show()
    },
  },
  computed: {},
})
</script>
